module.exports = __webpack_public_path__ + "img/newFSCL.5f84e6d8.png";